import React, { useState } from "react";
import StandardInputWrapper from "../UI/StandardInputWrapper";
import StandardFormItem from "../UI/StandardFormItem";
import StandardLabel from "../UI/StandardLabel";
import { useTranslation } from "react-i18next";
import ReactModal from "react-modal";
import DepositsCopy from "./DepositsCopy";
import StandardH2 from "../UI/StandardH2";

const PaymentOption = ({
  name,
  styles,
  classes,
  isDepositAvailable,
  paymentOptionSelected,
  formatCurrency,
  depositAmount,
  geo,
  depDateContext,
  cartMeta,
  handlePaymentChange,
  calculateDate,
  currency,
  hotelResortId,
  paymentOptionTitle,
  paymentOptionSubtext,
  shouldDisplay,
  brand
}) => {
  const { t } = useTranslation("common");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const DisplayDepositMessage = () => {
    const learnMoreSpan = (
          <span
            className={styles.depositsLearnMore}
            onClick={() => setIsModalOpen(!isModalOpen)}
            data-testid="learn-more-span"
          >
            {t("learn-more")}
          </span>
        );

    if (isDepositAvailable) {
      return depDateContext.depDate === "" ? (
        <p data-testid="no-deposit-text">
          {t("deposits-message-in-weeks", {
            weeks: Math.round(+cartMeta.payment_options.days / 7),
          })}{" "}
          {learnMoreSpan}
        </p>
      ) : (
        <p data-testid={`${name}-tab-text`}>
          {paymentOptionSubtext}{" "}
          {learnMoreSpan}
        </p>
      )
    } else {
        return (
      <p data-testid="no-deposit-text">
        {t((geo === 'en-au' ? "deposits-message-in-weeks-au" : "deposits-message-in-weeks"), {
          weeks: Math.round(+cartMeta.payment_options.days / 7),
        })}{" "}
        {learnMoreSpan}
      </p>)
    }
  }

  return (
    shouldDisplay && (
      <StandardFormItem
        className="radioItem"
        id={`payment-option-${name}-container`}
      >
        <StandardLabel
          htmlFor={`payment-option-${name}`}
          className={`radioLabel radioLabelDeposit ${
            !isDepositAvailable ? "noDeposit" : ""
          }`}
          selected={paymentOptionSelected}
        >
          <div className={styles.depositContainer}>
            <div className={brand !== 'Sw' && styles.radioButtonContainer}>
              <div className={brand !== 'Sw' && styles.radioBtn}>
                {paymentOptionSelected && (
                  <div className={styles.radioBtnSelected}></div>
                )}
              </div>
              <span className={styles.label} id={`${name}-title`}>
                {paymentOptionTitle}
              </span>
            </div>
            {brand !== 'Sw' && (
              <span id={`${name}-payment-amount`} className={styles.amount}>
                {formatCurrency(depositAmount.toFixed(2), geo)}
              </span>
            )}
          </div>
          {brand === 'Sw' && (
            <span id={`${name}-payment-amount`} className={styles.amount}>
              {formatCurrency(depositAmount.toFixed(2), geo)}
            </span>
          )}
          {brand !== 'Sw' && (
            <div
              className={`${styles.depositInfo} ${
                paymentOptionSelected ? styles.depositInfoSelected : ""
              }`}
              id={`${name}-subtext-wrapper`}
            >
              <DisplayDepositMessage />
            </div>
          )}
        </StandardLabel>
        <StandardInputWrapper className="radioWrapper">
          <input
            type="radio"
            id={`payment-option-${name}`}
            name="payment-option"
            value={name}
            className={classes}
            disabled={!isDepositAvailable && false}
            onChange={handlePaymentChange}
          />
          <span></span>
        </StandardInputWrapper>
        <ReactModal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          className={styles.depositsModal}
          overlayClassName={styles.depositsModalOverlay}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          htmlOpenClassName={styles.tester}
          onAfterOpen={() => {
            document.body.style.overflow = "hidden";
          }}
          onAfterClose={() => {
            document.body.style.overflow = "unset";
          }}
        >
          <div className={styles.depositsModalHeader}>
            <StandardH2>{paymentOptionTitle}</StandardH2>
            <div
              className={styles.depositsCloseButton}
              onClick={() => setIsModalOpen(false)}
            ></div>
          </div>
          <DepositsCopy
            styles={styles}
            currency={currency}
            amount={depositAmount}
            formatCurrency={formatCurrency}
            geo={geo}
            cutOffDate={calculateDate}
            standardCopy={!hotelResortId && true}
            hotelResortId={hotelResortId}
            refundable={name === "deposit" && true}
          />
        </ReactModal>
      </StandardFormItem>
    )
  );
};

export default PaymentOption;
